<script setup>
import { onMounted, ref, reactive } from 'vue'
import ButtonBack from '@/Shared/Buttons/ButtonBack'
import List from '@/Shared/List/List'
import useFavorites from '@/Shared/useFavorites.js'

const props = defineProps({
  category: String,
  categoryJ: String,
})

const favorite = reactive({
  favorites: [],
  others: [],
})

const emit = defineEmits(['change'])

const scrollAreaRef = ref()
const backBtnRef = ref()

const setScrollAreaHeight = () => {
  if (typeof window === 'undefined') return
  const backBtnH = backBtnRef.value.clientHeight
  const targetH = Math.trunc(window.innerHeight - scrollAreaRef.value.getBoundingClientRect().top) - backBtnH
  scrollAreaRef.value.style.maxHeight = targetH + 'px'
}

const { sortFavoriteList, subscribeFavoriteList } = useFavorites({ favorite: favorite, category: props.category })

onMounted(() => {
  sortFavoriteList()
  subscribeFavoriteList(sortFavoriteList)
  setScrollAreaHeight()
})
</script>

<template>
  <div class="w-full absolute top-0">
    <div ref="scrollAreaRef" class="relative w-full overflow-y-scroll scrollbar-hidden pt-[20px] px-[8vw] xs:px-[40px]">
      <List type="favorite" :category="props.category" :list="favorite.favorites" :title="`お気に入り${props.categoryJ}`" />
      <hr class="h-px border-b mb-[10px] border-b-black border-dotted" />
      <List type="favorite" :category="props.category" :list="favorite.others" :title="`${props.categoryJ}一覧`" :lead="`${props.categoryJ}名をクリックして、お気に入りに追加ください。`" />
    </div>
    <div ref="backBtnRef"><ButtonBack color="black" class="black px-[8vw] xs:px-[40px] py-[20px] sm:py-[30px] scale-[1] ml-[-3px]" @click="emit('change')" /></div>
  </div>
</template>
